// removed by extract-text-webpack-plugin
module.exports = {"base":"base___2_I5_","default":"default___3h9IR","outline":"outline___27YKd","small":"small___1AleN","medium":"medium___aAFkK","collapsed":"collapsed___1IS20","primary":"primary___g6C_q","secondary":"secondary___1unBa","brand":"brand___25EzA","darker":"darker___35ZvB","terciary":"terciary___3MeH2","correct":"correct___14FaE","wrong":"wrong___cZoTv","negative":"negative___3GVqO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Buttons/Button/index.scss
// module id = 74
// module chunks = 0